import { jsx as e, jsxs as n, Fragment as u } from "react/jsx-runtime";
import { useState as d, useMemo as i } from "react";
function w() {
  return /* @__PURE__ */ e(
    "svg",
    {
      width: "8",
      height: "8",
      viewBox: "0 0 8 8",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ e("path", { d: "M7.14998 0.854985C6.95498 0.659985 6.63999 0.659985 6.44498 0.854985L3.99999 3.29499L1.55499 0.849985C1.35999 0.654985 1.04499 0.654985 0.849985 0.849985C0.654985 1.04499 0.654985 1.35999 0.849985 1.55499L3.29499 3.99999L0.849985 6.44498C0.654985 6.63999 0.654985 6.95498 0.849985 7.14998C1.04499 7.34499 1.35999 7.34499 1.55499 7.14998L3.99999 4.70499L6.44498 7.14998C6.63999 7.34499 6.95498 7.34499 7.14998 7.14998C7.34499 6.95498 7.34499 6.63999 7.14998 6.44498L4.70499 3.99999L7.14998 1.55499C7.33998 1.36499 7.33998 1.04499 7.14998 0.854985Z" })
    }
  );
}
function f() {
  return /* @__PURE__ */ n(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ e("path", { d: "M1.25 12C1.25 6.08579 6.08579 1.25 12 1.25C17.9142 1.25 22.75 6.08579 22.75 12C22.75 17.9142 17.9142 22.75 12 22.75C6.08579 22.75 1.25 17.9142 1.25 12ZM12 2.75C6.91421 2.75 2.75 6.91421 2.75 12C2.75 17.0858 6.91421 21.25 12 21.25C17.0858 21.25 21.25 17.0858 21.25 12C21.25 6.91421 17.0858 2.75 12 2.75Z" }),
        /* @__PURE__ */ e("path", { d: "M12 7.25C12.4142 7.25 12.75 7.58579 12.75 8V13C12.75 13.4142 12.4142 13.75 12 13.75C11.5858 13.75 11.25 13.4142 11.25 13V8C11.25 7.58579 11.5858 7.25 12 7.25Z" }),
        /* @__PURE__ */ e("path", { d: "M10.9945 16C10.9945 15.4477 11.4422 15 11.9945 15H12.0035C12.5558 15 13.0035 15.4477 13.0035 16C13.0035 16.5523 12.5558 17 12.0035 17H11.9945C11.4422 17 10.9945 16.5523 10.9945 16Z" })
      ]
    }
  );
}
function x() {
  return /* @__PURE__ */ n(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ e("path", { d: "M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z" }),
        /* @__PURE__ */ e("path", { d: "M4.90003 19.75C4.71003 19.75 4.52003 19.68 4.37003 19.53C4.08003 19.24 4.08003 18.76 4.37003 18.47L18.37 4.47C18.66 4.18 19.14 4.18 19.43 4.47C19.72 4.76 19.72 5.24 19.43 5.53L5.43003 19.53C5.28003 19.68 5.09003 19.75 4.90003 19.75Z" })
      ]
    }
  );
}
function m() {
  return /* @__PURE__ */ n(
    "svg",
    {
      width: "22",
      height: "22",
      viewBox: "0 0 22 22",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ e("path", { d: "M0.25 11C0.25 5.08579 5.08579 0.25 11 0.25C16.9142 0.25 21.75 5.08579 21.75 11C21.75 16.9142 16.9142 21.75 11 21.75C5.08579 21.75 0.25 16.9142 0.25 11ZM11 1.75C5.91421 1.75 1.75 5.91421 1.75 11C1.75 16.0858 5.91421 20.25 11 20.25C16.0858 20.25 20.25 16.0858 20.25 11C20.25 5.91421 16.0858 1.75 11 1.75Z" }),
        /* @__PURE__ */ e("path", { d: "M15.7808 7.64012C16.0734 7.93327 16.073 8.40815 15.7799 8.70078L10.1099 14.3608C9.81689 14.6532 9.34238 14.653 9.04967 14.3603L6.21967 11.5303C5.92678 11.2374 5.92678 10.7625 6.21967 10.4697C6.51256 10.1768 6.98744 10.1768 7.28033 10.4697L9.58047 12.7698L14.7201 7.63918C15.0133 7.34655 15.4882 7.34697 15.7808 7.64012Z" })
      ]
    }
  );
}
function b() {
  return /* @__PURE__ */ n(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ e("path", { d: "M12 14.75C11.59 14.75 11.25 14.41 11.25 14V9C11.25 8.59 11.59 8.25 12 8.25C12.41 8.25 12.75 8.59 12.75 9V14C12.75 14.41 12.41 14.75 12 14.75Z" }),
        /* @__PURE__ */ e("path", { d: "M12 18C11.94 18 11.87 17.99 11.8 17.98C11.74 17.97 11.68 17.95 11.62 17.92C11.56 17.9 11.5 17.87 11.44 17.83C11.39 17.79 11.34 17.75 11.29 17.71C11.11 17.52 11 17.26 11 17C11 16.74 11.11 16.48 11.29 16.29C11.34 16.25 11.39 16.21 11.44 16.17C11.5 16.13 11.56 16.1 11.62 16.08C11.68 16.05 11.74 16.03 11.8 16.02C11.93 15.99 12.07 15.99 12.19 16.02C12.26 16.03 12.32 16.05 12.38 16.08C12.44 16.1 12.5 16.13 12.56 16.17C12.61 16.21 12.66 16.25 12.71 16.29C12.89 16.48 13 16.74 13 17C13 17.26 12.89 17.52 12.71 17.71C12.66 17.75 12.61 17.79 12.56 17.83C12.5 17.87 12.44 17.9 12.38 17.92C12.32 17.95 12.26 17.97 12.19 17.98C12.13 17.99 12.06 18 12 18Z" }),
        /* @__PURE__ */ e("path", { d: "M18.06 22.16H5.93998C3.98998 22.16 2.49998 21.45 1.73998 20.17C0.989976 18.89 1.08998 17.24 2.03998 15.53L8.09998 4.63003C9.09998 2.83003 10.48 1.84003 12 1.84003C13.52 1.84003 14.9 2.83003 15.9 4.63003L21.96 15.54C22.91 17.25 23.02 18.89 22.26 20.18C21.5 21.45 20.01 22.16 18.06 22.16ZM12 3.34003C11.06 3.34003 10.14 4.06003 9.40998 5.36003L3.35998 16.27C2.67998 17.49 2.56998 18.61 3.03998 19.42C3.50998 20.23 4.54998 20.67 5.94998 20.67H18.07C19.47 20.67 20.5 20.23 20.98 19.42C21.46 18.61 21.34 17.5 20.66 16.27L14.59 5.36003C13.86 4.06003 12.94 3.34003 12 3.34003Z" })
      ]
    }
  );
}
function v(t = "info") {
  switch (t) {
    case "success":
      return /* @__PURE__ */ e(m, {});
    case "warning":
      return /* @__PURE__ */ e(b, {});
    case "danger":
      return /* @__PURE__ */ e(x, {});
    default:
      return /* @__PURE__ */ e(f, {});
  }
}
const r = {
  info: "text-white bg-blue-800",
  success: "text-white bg-green-700",
  warning: "text-yellow-950 bg-yellow-500",
  danger: "text-white bg-rose-600"
}, C = {
  info: "text-blue-700 bg-blue-50",
  success: "text-green-900 bg-green-50",
  warning: "text-yellow-900 bg-yellow-50",
  danger: "text-rose-900 bg-rose-50"
}, s = {
  info: "text-blue-700 bg-white shadow-lg",
  success: "text-green-900 bg-white shadow-lg",
  warning: "text-yellow-900 bg-white shadow-lg",
  danger: "text-rose-900 bg-white shadow-lg"
}, o = {
  info: "text-blue-400 bg-zinc-800",
  success: "text-emerald-400 bg-zinc-800",
  warning: "text-yellow-500 bg-zinc-800",
  danger: "text-rose-400 bg-zinc-800"
};
function L(t = "info", l = "default") {
  return l === "dark" ? o[t] || o.info : l === "light" ? s[t] || s.info : l === "soft" ? C[t] || C.info : r[t] || r.info;
}
function M(t) {
  return "transition-opacity duration-1000 ease-out relative flex items-start p-4 " + (t.fullWidth ? "w-full" : "w-80") + " rounded-2xl " + L(t.color, t.variant);
}
function Z(t) {
  return t.variant === "light" ? "text-sm text-neutral-600" : t.variant === "dark" ? "text-sm text-neutral-400" : "text-sm";
}
function k(t) {
  const [l, c] = d(!0), a = i(() => M(t), [t]), h = i(() => Z(t), [t]), g = i(() => v(t.color), [t.color]);
  return l ? /* @__PURE__ */ n("div", { className: a, children: [
    t.hasIcon ? /* @__PURE__ */ e("div", { className: "w-8 shrink-0", children: g }) : null,
    /* @__PURE__ */ n("div", { className: "w-full", children: [
      t.title ? /* @__PURE__ */ e("div", { className: "mb-1 font-bold leading-none", children: t.title }) : null,
      /* @__PURE__ */ e("div", { className: h, children: t.children })
    ] }),
    t.dismissable ? /* @__PURE__ */ e("div", { className: "p-0 m-0 leading-none shrink-0", children: /* @__PURE__ */ n(
      "button",
      {
        onClick: () => c(!1),
        type: "button",
        className: "h-full pl-2 m-0 cursor-pointer",
        children: [
          /* @__PURE__ */ e(w, {}),
          " "
        ]
      }
    ) }) : null
  ] }) : /* @__PURE__ */ e(u, {});
}
export {
  k as Alert
};
